import $ from 'jquery';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery.js'

export default class Transition {
    constructor(params)
    {
        this.selectors = params;
    }

    init()
    {
        this.setupSelectors();
        this.setupEvents();
        this.startTransition();
    }

    setupSelectors()
    {
        this.usps = $(this.selectors);
    }

    setupEvents()
    {
        let me = this;

        $(window).on('changed.zf.mediaquery', function () {
            if (MediaQuery.atLeast('large')) {
                me.stopTransition();
            } else {
                me.startTransition();
            }
        });
    }

    transition(current)
    {
        let me = this;
        let next = (current + 1) === me.usps.length ? 0 : current + 1;

        if (!this.transitioning && this.active && this.usps.length > 0) {
            me.transitioning = true;

            setTimeout(function () {
                if (me.active) {
                    $(me.usps[current]).fadeOut(function () {
                        $(me.usps[next]).fadeIn(function () {
                            me.transitioning = false;
                            me.transition(next);
                        });
                        $(me.usps[next]).removeClass('show-for-large');
                    });
                }
            }, 5000);
        }
    }


    startTransition()
    {
        if (! this.active) {
            this.active = true;
            this.transition(0);
        }
    }

    stopTransition()
    {
        this.active = false;
        this.usps.show();
        this.usps.not(':first').addClass('show-for-large');
    }
}